// extracted by mini-css-extract-plugin
export default {"title":"new-item_title__DrKNs","itemSaveButton":"new-item_itemSaveButton__8NOAo"};